export default __webpack_public_path__ + "static/media/Logo.bcbe104c.png";